import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaExclamationTriangle, FaRedo, FaHome } from 'react-icons/fa';
import './ErrorState.css';

const ErrorState = ({
  title = "Something went wrong",
  message,
  actionLabel,
  onAction,
  showRetry = false,
  onRetry,
  showHome = false,
  onHome
}) => {
  const navigate = useNavigate();
  return (
    <motion.div
      className="error-state"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <motion.div
        className="error-state-icon"
        initial={{ scale: 0, rotate: -180 }}
        animate={{ scale: 1, rotate: 0 }}
        transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
      >
        <FaExclamationTriangle />
      </motion.div>
      <h2 className="error-state-title">{title}</h2>
      {message && <p className="error-state-message">{message}</p>}
      <div className="error-state-actions">
        {showRetry && onRetry && (
          <motion.button
            className="btn btn-primary error-state-action"
            onClick={onRetry}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaRedo /> Try Again
          </motion.button>
        )}
        {actionLabel && onAction && (
          <motion.button
            className="btn btn-primary error-state-action"
            onClick={onAction}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            {actionLabel}
          </motion.button>
        )}
        {showHome && (
          <motion.button
            className="btn btn-secondary error-state-action"
            onClick={onHome || (() => navigate('/feed'))}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <FaHome /> Go Home
          </motion.button>
        )}
      </div>
    </motion.div>
  );
};

export default ErrorState;

